
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.98 19.73a.86.86 0 000-.23v-.1a.88.88 0 00-.2-.3l-5.42-5.42-3.51-3.52a.871.871 0 00-.23-.16H16a1 1 0 00-1 1v38.65a1 1 0 001 1h28.13a1 1 0 001-1v-29.7s-.15-.19-.15-.22zm-8.92-6.45l1.26 1.27 4.25 4.25h-5.51v-5.52zM16.87 48.52V11.87h17.19v7.93a1 1 0 001 1H43v27.72H16.87zm21.17-20.24a1 1 0 01-1 1h-15a1 1 0 010-2h15a1 1 0 011 1zm0 6.32a1 1 0 01-1 1h-15a1 1 0 110-2h15a1 1 0 011 1zm0 6.32a1 1 0 01-1 1h-15a1 1 0 110-2h15a.999.999 0 011 1z"}})])
          )
        }
      }
    